<template>
	<div id="login" :class="school" :style="school?'background-image:url('+global.oss_website+'/pc/images/login/'+sch_prefix+'_login_bg.jpg);':''">
		<el-dialog title="使用教程" :visible.sync="dialogFormVisible" @close="closeDialogFn">
			<video-player class="VideoItem" ref="videoPlayer"
			:playsinline="true"
			:options="playerOptions"></video-player>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<div class="loginBox" :style="school?'background-image:url('+global.oss_website+'/pc/images/login/'+sch_prefix+'_login_banner.jpg?v='+$moment().startOf('day')+');':''">
			<div class="leftCon" v-if="school==''">
				<img :src="global.oss_website+'/pc/images/login/logo.jpg'" class="logo">
				<p class="logoDesc">让线上教育更轻松</p>
				<img :src="global.oss_website+'/pc/images/login/banner.jpg'" class="banner">
			</div>
			<div class="loginConBox" v-loading="loginload">
				<div class="loginCon" v-if="login_b=='forget'">
					<h3>忘记密码</h3>
					<el-form :model="passwordForm" :rules="passwordrules" ref="passwordForm" autocomplete="new-password" @keyup.enter.native="change_password()" class="acc_login_con">
						<el-form-item class="lineInput" prop="mobile">
							<span>手机号</span>
							<el-input v-model.trim="passwordForm.mobile" type="number" name="mobile" id="mobile" placeholder="手机号"></el-input>
						</el-form-item>
						<el-form-item class="lineInput df" prop="image_captcha" >
							<span>图形验证码</span>
							<el-input v-model="passwordForm.image_captcha" type="text" name="image_captcha" id="image_captcha" placeholder="图形验证码"></el-input>
							<img :src="captcha_img.img" class="image_captcha" alt="" @click="verification_code('')">
						</el-form-item>
						<el-form-item class="lineInput df" prop="captcha">
							<span>短信验证码</span>
							<el-input v-model="passwordForm.captcha" type="text" name="captcha" id="captcha" placeholder="短信验证码" autocomplete="off"></el-input>
							<el-button type="primary" @click="getCaptcha('')" v-if="count_down==0">获取验证码</el-button>
							<div v-else style="color: #177fd6;">{{count_down}}</div>
						</el-form-item>
						<el-form-item class="lineInput df" prop="new_password">
							<span>新密码</span>
							<el-input v-model.trim="passwordForm.new_password" show-password type="password" name="new_password" id="new_password" placeholder="新密码" autocomplete="new-password"></el-input>
						</el-form-item>
						<el-form-item class="lineInput df" prop="confirm" style="margin-bottom: 10px;">
							<span>确认密码</span>
							<el-input v-model.trim="passwordForm.confirm" type="text" show-password name="confirm" id="confirm" placeholder="确认密码" autocomplete="new-password"
							 @paste.native.capture.prevent="false"></el-input>
						</el-form-item>
						<div class="ctrlBtn" >
							<a href="#" @click="login_b='login'">返回登录</a>
						</div>
						<el-button type="primary" class="btn loginBtn" @click="change_password()">提交</el-button>
					</el-form>
				</div>
				<div class="loginCon" v-show="login_b=='login'">
					<ul class="login_port">
						<li v-for="(item, index) in port" :key="index" v-if="item.link!='teacher'||(item.link=='teacher'&&temp.login_port)"
						 :class="{act: port_computed(item.link)}"
						 @click="location(item.link)">{{item.text}}</li>
					</ul>
					<ul class="fashion">
						<li v-for="(item,key,index) in fashion" :key='index' :class="index == login_fashion?key+' act':key" @click="login_fashion = index" v-if="school==''">
							<i class="iconfont" v-html='item.icon'></i>{{item.text}}
						</li>
					</ul>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" autocomplete="auto" @keyup.enter.native="login('ruleForm')" v-show="login_fashion == 0" class="acc_login_con">
						<el-form-item class="lineInput" prop="name">
							<span>身份证</span>
							<el-input v-model="ruleForm.name" type="text" name="uname" id="uname" placeholder="身份证"></el-input>
						</el-form-item>
						<el-form-item class="lineInput" prop="pwd">
							<span>密码</span>
							<el-input v-model="ruleForm.pwd" type="password" show-password name="upwd" id="upwd" placeholder="密码"></el-input>
							<!-- <p class="pasBtn show iconfont">&#xe67f;</p> -->
						</el-form-item>
						<el-form-item class="lineInput df" prop="image_captcha" v-if="temp.login.image_captcha&&use_captcha==1">
							<span>图形验证码</span>
							<el-input v-model="ruleForm.image_captcha" type="text" name="image_captcha" id="image_captcha" placeholder="图形验证码"></el-input>
							<img :src="ruleForm_captcha_img.img" class="image_captcha" alt="" @click="verification_code('ruleForm_')">
						</el-form-item>
						<el-form-item class="lineInput df" prop="captcha" v-if="temp.login.captcha&&use_captcha==1">
							<span>短信验证码</span>
							<el-input v-model="ruleForm.captcha" type="text" name="captcha" id="captcha" placeholder="短信验证码" autocomplete="off"></el-input>
							<el-button type="primary" @click="getCaptcha('ruleForm')" v-if="ruleForm_count_down==0">获取验证码</el-button>
							<div v-else style="color: #177fd6;">{{ruleForm_count_down}}</div>
						</el-form-item>
						<div class="ctrlBtn" >
							<a href="#" v-if="temp.login.phone_login" @click="code_password" style="float: left;">手机验证码登录</a>
							<a href="#" v-if="temp.login.reset_pwd" @click="forgot_password">忘记密码</a>
						</div>
						<el-button type="primary" class="btn loginBtn" @click="login('ruleForm')">登录</el-button>
						<!-- <el-button type="primary" class="btn videoBtn" @click="dialogFormVisible = true">使用教程</el-button> -->
					</el-form>
					<div v-show="login_fashion == 1" class="qrcode_login_con">
						<div id="login_container" v-show="wechat_step == 0"></div>
						<el-form v-show="wechat_step == 1" :model="wechatForm" :rules="rules" ref="wechatForm" autocomplete="auto" @keyup.enter.native="login('wechatForm')" class="wechat_login_con">
							<div class="authHead">
								<!-- <div class="backBox">
									<p class="back_tit">登录绑定</p>
								</div> -->
								<p class="authDesc">请输入您的登录账号登录</p>
							</div>
							<el-form-item class="lineInput" prop="name">
								<span>身份证</span>
								<el-input v-model="wechatForm.name" type="text" name="wxname" id="wxname" placeholder="身份证"></el-input>
							</el-form-item>
							<el-form-item class="lineInput" prop="pwd">
								<span>密码</span>
								<el-input v-model="wechatForm.pwd" type="password" show-password name="wxpwd" id="wxpwd" placeholder="密码"></el-input>
							</el-form-item>
							<el-form-item class="lineInput df" prop="image_captcha"  v-if="temp.qrLogin.image_captcha&&use_captcha==1">
								<span>图形验证码</span>
								<el-input v-model="wechatForm.image_captcha" type="text" name="image_captcha" id="image_captcha" placeholder="图形验证码"></el-input>
								<img :src="wechatForm_captcha_img.img" class="image_captcha" alt="" @click="verification_code('wechatForm_')">
							</el-form-item>
							<el-form-item class="lineInput df" prop="captcha" v-if="temp.qrLogin.captcha&&use_captcha==1">
								<span>短信验证码</span>
								<el-input v-model="wechatForm.captcha" type="text" name="captcha" id="captcha" placeholder="短信验证码" autocomplete="off"></el-input>
								<el-button type="primary" @click="getCaptcha('wechatForm')" v-if="wechatForm_count_down==0">获取验证码</el-button>
								<div v-else style="color: #177fd6;">{{wechatForm_count_down}}</div>
							</el-form-item>
							<el-button type="primary" class="btn loginBtn" @click="login('wechatForm')">登录</el-button>
						</el-form>
					</div>
				</div>
				<div class="loginCon" v-if="login_b=='code'">
					<h3>手机号登录</h3>
					<el-form :model="codeForm" :rules="coderules" ref="codeForm" autocomplete="new-password" @keyup.enter.native="change_password()" class="acc_login_con">
						<el-form-item class="lineInput" prop="mobile">
							<span>手机号</span>
							<el-input v-model="codeForm.mobile" type="text" name="mobile" id="mobile" placeholder="手机号"></el-input>
						</el-form-item>
						<el-form-item class="lineInput df" prop="image_captcha">
							<span>图形验证码</span>
							<el-input v-model="codeForm.image_captcha" type="text" name="image_captcha" id="image_captcha" placeholder="图形验证码"></el-input>
							<img :src="codeForm_captcha_img.img" class="image_captcha" alt="" @click="verification_code('codeForm_')">
						</el-form-item>
						<el-form-item class="lineInput df" prop="captcha">
							<span>短信验证码</span>
							<el-input v-model="codeForm.captcha" type="text" name="captcha" id="captcha" placeholder="短信验证码" autocomplete="off"></el-input>
							<el-button type="primary" @click="getCaptcha('codeForm')" v-if="codeForm_count_down==0">获取验证码</el-button>
							<div v-else style="color: #177fd6;">{{codeForm_count_down}}</div>
						</el-form-item>
						<div class="ctrlBtn" >
							<a href="#" @click="login_b='login'">返回登录</a>
						</div>
					</el-form>
					
					<el-button type="primary" class="btn loginBtn" @click="code_login()">提交</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'qsxueli'
	,props:["muban_bol"]
	,data () {
		var validatePass = (rule, value, callback) => {
			let pwdReg = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8}');
        	if (value === '' || value === undefined) {
        	  callback(new Error('请输入密码'));
        	} else if(!pwdReg.test(value)){
				callback(new Error('密码至少包含字母、数字、特殊字符各1位,总长度8位及以上!'));
			} else {
        	  callback();
        	}
		}
		var validatePass2 = (rule, value, callback) => {
        	if (!value) {
        	  callback(new Error('请再次输入密码'));
        	} else if (value !== this.passwordForm.new_password) {
        	  callback(new Error('两次输入密码不一致!'));
        	} else {
        	  callback();
        	}
		}
		return {
      		temp: this.temp.login,
			// port: 'web',
			//忘记密码图形验证码
			captcha_img:{
				image_captcha:''
			},
			//登录图形验证码
			ruleForm_captcha_img:{
				image_captcha:''
			},
			//验证码登录图形验证码
			codeForm_captcha_img:{
				image_captcha:''
			},
			//绑定账号验证码
			wechatForm_captcha_img:{
				image_captcha:''
			},
			ruleForm: {
				name:'',
				pwd:'',
				captcha:this.$store.state.app_config.user && this.$store.state.app_config.user.login.use_captcha==1?'':'-',
				image_captcha:''
			},
			passwordForm:{//重置密码
				mobile:'',
				image_captcha:''
			},
			wechatForm: {
				name:'',
				pwd:'',
				captcha:this.$store.state.app_config.user && this.$store.state.app_config.user.login.use_captcha==1?'':'-',
				image_captcha:''
			},
			codeForm:{
				mobile:'',
				captcha:'',
				image_captcha:''
			},
			port:[{
				link:'web',
				text:'学生登录',
				// show:true
			},{
				link:'teacher',
				text:'教师登录',
				// show:!this.$store.state.research_institute
			}],
			fashion:{
				acc:{
					icon:'&#xe683;',
					text:'账号登录',
				} ,wechat:{
					icon:'&#xe607;',
					text:'微信登录',
				} },
			login_fashion:0,
			wechat_step:0,
			rules: {
				//required：是否必填，message错误提示内容，trigger触发方式
				name: [
					{ required: true, message: '请输入身份证', trigger: 'blur' },
				],
				pwd: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
				],
			},
			coderules:{
				mobile: [
					{ required: true, message: '请输入11位的手机号', trigger: 'blur' },
					{ min: 11, max:11, message: '请输入11位的手机号', trigger: 'blur' }
				],
				captcha: [
					{ required: true, message: '请输入短信验证码', trigger: 'blur' },
				],
			},
			passwordrules:{
				mobile: [
					{ required: true, message: '请输入11位的手机号', trigger: 'blur' },
					{ min: 11, max:11, message: '请输入11位的手机号', trigger: 'blur' }
				],
				captcha:this.$store.state.app_config.user && this.$store.state.app_config.user.login.use_captcha==1?[
					{ required: true, message: '请输入短信验证码', trigger: 'blur' },
				]:false,
				new_password: [
					{ validator: validatePass, trigger: 'blur' },
				],
				confirm: [
					{ validator: validatePass2, trigger: 'blur' },
				],
				// image_captcha: [
				// 	{ required: true, message: '请输入验证码', trigger: 'blur' },
				// ],
			},
			dialogFormVisible: false,
			playerOptions:{		//播放器参数
				// playbackRates: [1.0],		//播放速度  0.7, 1.0, 1.5, 2.0
				autoplay: false,			//为true时，浏览器准备好时开始播放
				muted: false,			//默认情况下将静音
				loop: false,			//视频循环播放
				preload: 'auto',			//建议浏览器在video加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为
				language: 'zh-CN',			//播放器语言
				aspectRatio: '16:9',	//将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例
				fluid: true,	//当true时，video.js player将按比例缩放以适应容器
				flash: { hls: { withCredentials: false } },
        		html5: { hls: { withCredentials: false } },
				sources:[{
					type: "video/mp4",
					src: "https://learn.qsxueli.com/sv/43959df0-17885c9bf04/43959df0-17885c9bf04.mp4"
				}],
				poster: "",
				width: document.documentElement.clientWidth,
				notSupportedMessage:"此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
				controlBar:{
					timeDivider: true,			//当前时间和持续时间的分隔符
					durationDisplay:true,			//显示持续时间
					remainingTimeDisplay:true,		//是否显示剩余时间功能
					fullscreenToogle:true		//全屏按钮
				},
				playtimes:100, //视频观看起点
			},
			loginload:false,
			// 学校变量
			school: '',
			sch_prefix: '',			// 学校二级域名
			//是否正在请求图形验证码
			operating:false,
			//是否真在请求短信验证码
			short_message:false,
			//发送短信倒计时
			count_down:0,
			ruleForm_count_down:0,
			wechatForm_count_down:0,
			codeForm_count_down:0,
			// forget  忘记
			// login 登录
			// code 验证码登录
			login_b:'login',
			use_captcha:false
		}
	}
	,mounted:function(){
		// use_captcha
		if(this.$store.state.app_config.user) this.use_captcha = this.$store.state.app_config.user.login.use_captcha
		let that = this
			,src
		if(process.env.NODE_ENV == 'development'){
			src = window.location.origin+'/#/web/login/'
		}else{
			src = window.location.origin+'/web/#/web/login/'
		}
		new WxLogin({
			id:"login_container",//div的id
			appid: "wx102350877e4d11b8",
			scope: "snsapi_login",//写死
			redirect_uri:escape(src),
			state: "123",
			style: "black",//二维码黑白风格        
			href: 'https://xuexi.qsxueli.com/web/qrcode.css'
		});
		// 检测是否有code值
		if(this.$selfjs.getParamString("code")){
			this.wechat_login()
		}
		var token=this.$cookies.get("token");
		if(token){
			this.$router.push({
				path: '/web/' + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
				query: '',
				params: {
					page: 'exam_list'
				}
			})
		}
		// 设置院校登录页样式
		let loca_prefix = window.location.hostname.split(".xuexi.")
		if(window.location.hostname.includes(".xuexi.") && loca_prefix[0] != 'test' && loca_prefix[0] != '404' && loca_prefix[0] != '' && process.env.NODE_ENV === 'production'){
			let sch_prefix = loca_prefix[0].split('.')
			this.school = 'sch'
			this.sch_prefix = sch_prefix[0]
		}
		if (this.use_captcha==1) {
			this.verification_code('ruleForm_')
		}
		
		// if(window.location.hostname == 'zsc.xuexi.qsxueli.com'){
		// 	this.school = 'zsc'
		// }
		// if(window.location.hostname == 'zhku.xuexi.qsxueli.com'){
		// 	this.school = 'zhku'
		// }
	}
	,methods:{
		port_computed(link){
			return window.location.pathname.indexOf(link) > -1
		},
		location(link){
			window.location.href = '/'+link+'/'
		},
		error(m) {
			this.$message.error(m);
		}
		,login(formName){
			let that=this
				,link = '/login/password'
				
			if(formName == 'ruleForm'){
				link = '/login/password'
			}else if(formName == 'wechatForm'){
				link = '/login/wechat_bind'
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					const url = this.global.serverSrc+this.global.qianzui+link;
					this.loginload = true
					let logininfo = {
						mobile:that[formName].name
						,password:that[formName].pwd
						,captcha:that.temp.login.captcha?'--':that[formName].captcha
					}
					
					//判断是否有绑定微信ID
					if(that.wechat_login_id){
						logininfo.id = that.wechat_login_id
					}
					this.$ajax.post(
						url
						,this.$qs.stringify(logininfo)
						// ,{headers: {
						// 	'Content-Type': 'application/json',
						// 	// auth: '123'
						// }}
					)
					.then((res)=>{
						that.loginload = false
						res=res.data;
						if(res.ok){
							that.login_after_fn(res)
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
			// let margin=document.body.clientHeight-$(".loginBox").height();
			// $("#login").css("padding-top",margin/2)
		}
		//触发微信登录
		,wechat_login(){
			let that = this
			this.loginload = true
			this.login_fashion = 1
			this.verification_code('wechatForm_')
			this.$ajax.get(
				this.global.serverSrc + this.global.qianzui + '/login/wechat_login',{
					params:{
						code:this.$selfjs.getParamString("code")
					}
				}
			)
			.then(function (res){
				let resData = res.data
				that.loginload = false
				if(resData.code==0){
					let data=resData.data
					// that.global.token="Bearer "+data.token	//保存token
					that.$cookies.set("token", "Bearer "+data.token, 0)

					// 设置请求头token
					// that.$ajax.defaults.headers.common['Authorization'] = "Bearer "+data.token

					that.$emit("swmuban",true);		//修改app.vue 的 muban_bol 值
					that.$router.push("/web/" + this.$store.state.defaultIndex);
					localStorage.message_popup = true		// 开启新消息提醒
				}else if(resData.code==2){			//返回2则需要绑定账号
					that.wechat_step = 1		//跳转到微信绑定
					that.wechat_login_id = resData.data.id
				}
			})
		}
		,closeDialogFn(){
			// console.log(21);
			this.$refs.videoPlayer.player.pause()
		},
		//请求图形验证码
		async verification_code(text){
			if (!this.operating) {
				let that = this
				this.operating = true
				const url = this.global.serverSrc+this.global.qianzui+'/captcha/image';
				await this.$ajax.get(
					url
				)
				.then((res)=>{
					that[text+'captcha_img'] = res.data.data
					that.operating = false
				})
				.catch(function (res){
					that.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~')
				});
			}
		}
		//忘记密码
		,forgot_password(){
			this.login_b = 'forget'
			this.verification_code('')
		}
		//获取验证码
		,getCaptcha(text){
			let data = {}
			let text_o = ''
			// console.log(text);
			if (text=='wechatForm') {
				// console.log(text);
				text_o = text + '_'
				if (!this[text].name) {
					this.$message.error('请输入身份证');
					return false
				}else if(!this[text].image_captcha) {
					this.$message.error('请输入图形验证码');
					return false
				}
				data = {
					mobile:this[text].name,
					image_captcha:this[text].image_captcha,
					scene:'login',
					image_key:this[text_o+'captcha_img'].key,
				}
			}else if(text=='codeForm'){
				text_o = text + '_'
				if (!this.codeForm.mobile) {
					this.$message.error('请输入手机号');
					return false
				}else if(!this.codeForm.image_captcha) {
					this.$message.error('请输入图形验证码');
					return false
				}
				data = {
					mobile:this.codeForm.mobile,
					image_captcha:this.codeForm.image_captcha,
					scene:'login_mobile',
					image_key:this.codeForm_captcha_img.key,
				}
			}else if(text=='ruleForm'){
				text_o = text + '_'
				if(!this.ruleForm.image_captcha) {
					this.$message.error('请输入图形验证码');
					return false
				}else if (!this.ruleForm.name) {
					this.$message.error('请输入账号');
					return false
				}
				data = {
					mobile:this.ruleForm.name,
					image_captcha:this.ruleForm.image_captcha,
					scene:'login',
					image_key:this.ruleForm_captcha_img.key,
				}
			}else{
				if (!this.passwordForm.mobile) {
					this.$message.error('请输入手机号');
					return false
				}else if(!this.passwordForm.image_captcha) {
					this.$message.error('请输入图形验证码');
					return false
				}
				data = {
					mobile:this.passwordForm.mobile,
					image_captcha:this.passwordForm.image_captcha,
					scene:'password_reset',
					image_key:this.captcha_img.key,
				}
			}
			

			

			let that = this
			let url = this.global.serverSrc+this.global.qianzui+'/captcha/sms';
			this.short_message = true
			const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
			this.$ajax.post(
				url,
				this.$qs.stringify(data)
			).then((res)=>{
				loading.close()
				// that.verification_code(text_o)
				if (res.data.code==0) {
					that[text_o+'count_down'] = 60
					let int = setInterval(function(){
						that[text_o+'count_down'] --
						if (that[text_o+'count_down'] ==0) {
							window.clearInterval(int)
						}
						
					},1000)
					// that.success('发送成功')
					that.$message({
        				message: res.data.message,
        				type: 'success'
        			});
				}
			}).catch(_ => {
				// that.verification_code(text_o)
				// console.log(_);
				loading.close()
				that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~');
			});
		},
		//修改密码
		change_password(){
			this.$refs.passwordForm.validate((valid) => {
				// console.log(valid);
				if (valid) {
					const url = this.global.serverSrc+this.global.qianzui+'/password/resetPassword';
					this.loginload = true
					let that = this
					let logininfo = {
						mobile:that.passwordForm.mobile
						,password:that.passwordForm.new_password
						,captcha:that.passwordForm.captcha
					}
					this.$ajax.post(
						url
						,this.$qs.stringify(logininfo)
					)
					.then((res)=>{
						that.loginload = false
						// console.log(res);
						if(res.data.code==0){
							that.$message.success('修改成功！即将跳转到登录界面！')
							window.setTimeout(function(){
								that.login_b = 'login'
								that.passwordForm = {
									mobile:'',
									image_captcha:'',
									captcha:'',
									new_password:'',
									confirm:''
								}
							},2000)
						}
					})
				}
			});
		},
		//显示手机号登录
		code_password(){
			this.login_b = 'code'
			this.verification_code('codeForm_')
		},
		login_after_fn(res){
			let that = this
			let data=res.data
			// that.global.token="Bearer "+data.token	//保存token
			that.$cookies.set("token", "Bearer "+data.token, 0)
			// 设置请求头token
			// that.$ajax.defaults.headers.common['Authorization'] = "Bearer "+data.token
			that.$emit("swmuban",true);		//修改app.vue 的 muban_bol 值
			localStorage.message_popup = true		// 开启新消息提醒
			localStorage.max_term_popup = true		// 开启超前课程提醒
			// window.location.href = window.location.origin
			// that.$router.push("/web/" + this.$store.state.defaultIndex);
			
			this.$router.push({
				path: '/web/' + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
				query: '',
				params: {
					page: 'exam_list'
				}
			})
		},
		//手机号登录接口
		code_login(){
			let that = this
			this.$refs.codeForm.validate((valid) => {
				if (valid) {
					let link = '/login/mobile'
					const url = this.global.serverSrc+this.global.qianzui+link;
					this.loginload = true

					let logininfo = {
						mobile:that.codeForm.mobile
						,captcha:that.codeForm.captcha
						,image_captcha:that.codeForm.image_captcha
					}
					
					this.$ajax.post(
						url
						,this.$qs.stringify(logininfo)
					)
					.then((res)=>{
						that.loginload = false
						res=res.data;
						if(res.ok){
							that.login_after_fn(res)
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
	}
	,watch: {
		'$route' (to, from) {
			let that = this
			if(this.$route.query.code){
				this.wechat_login()
			}
		},
		// 检测标题尾巴是否有改变
		'$store.state.titleAfter' (to, from) {
			let client_type = this.$selfjs.getParamString('client-type')
			if(client_type && !client_type.includes("qs-app")){
				document.title = this.$route.meta.title + this.$store.state.titleAfter
			}
		},
		// 根据模板修改登录页背景图
		'$store.state.app_config.platform_code' (to, from) {
			if(to == 'platform.en_degree'){
				this.school = 'sch'
				this.sch_prefix = 'en_degree'
			}
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- scoped单页面有效属性 -->

<style>
/* body #app{min-height:100%;} */
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/components/login_com/qsxueli.vue